<div class="dashboardAccounts">
    <div class="links">
        <a [routerLink]="['/dashboard/accounts/requests']" routerLinkActive="router-link-active">Account Requests</a>

        <a [routerLink]="['/dashboard/accounts/all']" routerLinkActive="router-link-active">All Accounts</a>
        
        <a [routerLink]="['/dashboard/accounts/deleted']" routerLinkActive="router-link-active">Deleted Accounts</a>
    </div>
</div>

<div class="subSection">
    <div class="requests" *ngIf="section == 'requests' ">
        <div class="title">Account requests</div>
        <app-csv-download [data]="newRequestsCsv" filename="account_requests.csv"></app-csv-download>
    </div>
    <div class="resultsWrapper" *ngIf="hashmap().size && loaded">

        <!-- <div class="days" *ngFor="let dayList of hashmap">
            <div class="dayTitle">
                test {{dayList}}
            </div>
        </div> -->

        <div class="row" *ngFor="let entry of hashmap().entries()">
            <!-- <h2>Key: {{ entry[0] }}</h2> -->
            <div class="dayTitle">
                {{entry[0]}}
            </div>

            <div class="list">
                <div class="item" *ngFor="let request of entry[1]">
                    <div class="itemBox" [class]="request.state">

                        <div class="label">
                            NAME
                        </div>
                        <div class="name">
                            {{request.firstName}} {{request.lastName}}
                        </div>
    
                        <div class="label">
                            email
                        </div>
                        <div class="email">
                            {{request.email}}
                        </div>
    
                        <div class="label">
                            PHONE
                        </div>
                        <div class="phone">
                            {{request.phone}}
                        </div>

                        <div class="label">
                            STATE
                        </div>
                        <div class="phone">
                            {{request.state}}
                        </div>
                    </div>

                    <div class="buttons" *ngIf="request.state == 'Pending'">
                        <div class="button Approve" (click)="approve(request)">
                            <div class="label">Approve</div>
                        </div>
                        <div class="button Deny" (click)="deny(request)">
                            <div class="label">Deny</div>
                        </div>
                    </div>
                </div>
            </div>
            
        </div>
    </div>
</div>